export default class DeviceConfigService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/deviceConfig/' + id, params)
	}

	getDeviceConfigResult(id, params) {
		return this.apiService.callGet('me/deviceConfig/' + id + '/result', params)
	}


	getEntities(params) {
		return this.apiService.callGet('me/deviceConfigs', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/deviceConfig/' + id, params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/deviceConfig/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/deviceConfig/', params);
	}

	getDependency() {
		return this.apiService.callGet('me/deviceConfig/dependency/')
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceConfigService.js